/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

import './install-global-dom-shim.js';
export * from './render-lit-html.js';
